const getSignInMessage = nonce => {
  return `Sign this message to verify your address, login to BlockRacers.io and start exploring! Your unique message id is: ${nonce}`;
};

module.exports = {
  getSignInMessage,
};
